import * as React from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Fragment } from "react";

import { Nullable } from "types";

interface PropsType {
  label: string;
  message: string;
  paydays: Date[];
}

export default function SamplePaymentSchedule(
  props: PropsType,
): Nullable<JSX.Element> {
  const { label, message, paydays } = props;

  return (
    <div className="form--fieldset" id="sample-payment-schedule">
      <div className="content">
        <header className="blue">
          <div className="badge">
            <i className="fas fa-calendar" />
          </div>

          <h2>
            Sample <b>{label}</b> Schedule
          </h2>
        </header>

        <div className="form--description">
          <h4>{message}</h4>
        </div>

        <div className="calendar-wrapper">
          <DatePicker
            includeDates={paydays}
            inline
            onChange={(): void => {}}
            renderDayContents={(day): JSX.Element => (
              <Fragment>
                <div className="circle" />
                <span>{day}</span>
              </Fragment>
            )}
            selected={paydays[0]}
          />
        </div>
      </div>
    </div>
  );
}
